import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F0] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md eo-card p-8">
        <div className="font-mono-eo text-[10px] uppercase tracking-widest text-[#8A8A80]">// Password Recovery</div>
        <h1 className="font-heading text-[28px] font-bold mt-1">Forgot your password?</h1>
        {sent ? (
          <div className="mt-6 border border-[#2A9D8F] bg-[#E6F4F1] p-4 flex gap-3 items-start">
            <MailCheck size={18} className="text-[#2A9D8F] mt-0.5 shrink-0" />
            <div className="text-[13px] text-[#0A0A0A]">
              If an account exists for <b>{email}</b>, a password reset link has been emailed. The link is valid for <b>30 minutes</b>.
              <div className="mt-2 text-[12px] text-[#5C5C54]">Please also check your spam folder.</div>
            </div>
          </div>
        ) : (
          <>
            <p className="text-[14px] text-[#5C5C54] mt-3">Enter your registered email and we&apos;ll send you a link to set a new password.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="block text-[12px] font-mono-eo uppercase tracking-widest text-[#5C5C54] mb-1.5">Email</label>
                <input
                  data-testid="forgot-email-input"
                  type="email" required autoFocus
                  value={email} onChange={(e) => setEmail(e.target.value)}
                  className="eo-input"
                />
              </div>
              <button data-testid="forgot-submit-btn" disabled={busy} className="eo-btn-primary w-full">
                {busy ? "Sending..." : "Send reset link"}
              </button>
            </form>
          </>
        )}
        <div className="mt-6 pt-6 border-t border-[#DCD9D0] text-[12px] text-[#8A8A80]">
          Remembered it? <Link to="/login" className="text-[#1D3557] underline">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
